import { Reveal } from '../components/hareket'
import { Baslik, ButonLink, SayfaUstu, Section } from '../components/ui'
import { useHead } from '../lib/head'

export function Bulunamadi() {
  useHead({ title: 'Sayfa bulunamadı', description: 'Aradığınız sayfa yok ya da taşındı.' }, '/404')
  return (
    <SayfaUstu>
      <Section dar className="text-center">
        <Reveal>
          <Baslik
            seviye="h1"
            eyebrow="404"
            baslik="Bu sayfa yok"
            metin="Adres değişmiş ya da yanlış yazılmış olabilir. Ana sayfadan devam edin."
            hizala="center"
          />
          <div className="mt-8">
            <ButonLink to="/" ok>
              Ana sayfa
            </ButonLink>
          </div>
        </Reveal>
      </Section>
    </SayfaUstu>
  )
}
